const EVIDENCE_VERIFICATION_TYPE = 'evidence'

const referenceId = value => {
    if (value && typeof value === 'object') {
        return value.id === null || typeof value.id === 'undefined'
            ? null
            : String(value.id)
    }

    return value === null || typeof value === 'undefined' ? null : String(value)
}

const uniqueReferences = values => {
    const seen = new Set()

    return (Array.isArray(values) ? values : []).filter(value => {
        const id = referenceId(value)
        if (id === null || seen.has(id)) {
            return false
        }

        seen.add(id)
        return true
    })
}

const buildRequestedVerificationDocumentCoverage = ({
    requestedDocuments = [],
    requestedEvidenceReportTypes = [],
    providedDocuments = [],
} = {}) => {
    const requestedTypes = uniqueReferences(requestedDocuments).map(String)
    const evidenceTypes = uniqueReferences(requestedEvidenceReportTypes)
    const providedByType = providedDocuments.reduce((documents, document) => {
        const type = document && (document.verificationType || document.type)
        if (!type) {
            return documents
        }

        const normalizedType = String(type)
        if (!documents.has(normalizedType)) {
            documents.set(normalizedType, [])
        }
        documents.get(normalizedType).push(document)

        return documents
    }, new Map())

    return requestedTypes.map(type => {
        const matchingDocuments = providedByType.get(type) || []
        if (type !== EVIDENCE_VERIFICATION_TYPE || evidenceTypes.length === 0) {
            return {
                type,
                isProvided: matchingDocuments.length > 0,
                requestedEvidenceReportTypes: [],
                providedEvidenceReportTypeCount: 0,
            }
        }

        const providedEvidenceTypeIds = new Set(matchingDocuments.reduce((ids, document) => (
            ids.concat(Array.isArray(document.documentTypes) ? document.documentTypes : [])
        ), []).map(referenceId).filter(id => id !== null))
        const providedEvidenceReportTypeCount = evidenceTypes.filter(typeReference => (
            providedEvidenceTypeIds.has(referenceId(typeReference))
        )).length

        return {
            type,
            isProvided: providedEvidenceReportTypeCount === evidenceTypes.length,
            requestedEvidenceReportTypes: evidenceTypes,
            providedEvidenceReportTypeCount,
        }
    })
}

export {
    buildRequestedVerificationDocumentCoverage,
    EVIDENCE_VERIFICATION_TYPE,
}

export default buildRequestedVerificationDocumentCoverage
